export default "__VITE_ASSET__D0CWNNC3__"